export default __webpack_public_path__ + "static/media/4T0A9732.20dc4481.jpg";